<script setup>
import PageTransition from "./PageTransition.vue";
import {inject} from "vue";

const props = defineProps({
    beforeIndex: Number,
    previousIndex: Number,
    message: String,
    selections: Array,
    image: {
        type: String,
        required: false,
        default: null
    },
    isTopReturn: Boolean

});
const emit = defineEmits(['changeIndex', 'resetInputValue']);
function select(index,key,value) {
    emit('changeIndex',index,key,value);
}
function getIndex(selection) {
    // 固定の値が入ってくる場合
    if (!isNaN(selection.index)) {
        return selection.index;
    }
    // computedの値が入ってくる場合
    return selection.index.value;
}
function getPreviousIndex() {
    if (!props.previousIndex) {
        return index - 1;
    }
    if (!isNaN(props.previousIndex)) {
        return props.previousIndex;
    }
    return props.previousIndex.value;
}
const PLAY_INFO1_INDEX = inject('PLAY_INFO1_INDEX');
const index = inject('index');
// プレイ状況の1に戻る
const returnPageIndex = PLAY_INFO1_INDEX;

</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <div id="guidance-wrapper" class="uk-flex-1 uk-margin uk-flex uk-flex-column uk-overflow-auto uk-flex-center">
                <div class="uk-card uk-card-default uk-width-1-1 uk-background-muted uk-text-left" style="padding: 20px;white-space: pre-wrap;">
                    {{message}}
                    <router-link :to="'/form/' + returnPageIndex">復旧したいアカウントに関する情報の入力に戻る</router-link>
                </div>
            </div>
            <page-transition
                :index="index"
                :previous-index="getPreviousIndex()"
                :next-index="null"
                :isActiveButton="true"
                :selections="selections"
                :is-top-return="isTopReturn"
            ></page-transition>
        </div>
    </div>
</template>

<style scoped>
#guidance-wrapper {
    align-items: center;
}
</style>